import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';

@Component({
  selector: 'app-data-processing-status',
  templateUrl: './data-processing-status.component.html',
  styleUrls: ['./data-processing-status.component.scss']
})
export class DataProcessingStatusComponent implements OnInit {
  @Input() progress_details: any;
  commonVariableList: any = { "columnList": [], "items": [], "approvals": [] }
  company_setup: any = {};
  color_list:any=[
    {'range':30,'color':'red'},
    {'range':60,'color':'orange'},
    {'range':80,'color':'blue'},
    {'range':100,'color':'green'}
  ]

  @Output()
  sendAction = new EventEmitter()
  constructor(private toasterService: ToasterService, private webService: WebServiceService) { }

  ngOnInit() {
    if (this.progress_details.id) {
      this.commonVariableList.items = [];
      this.GetCompanySetUpData();
    }
  }
 
  GetCompanySetUpData() {
    if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
      return false;
    }
    let req = {
    }
    this.company_setup = {}
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup = {}
          this.company_setup = data.response ? data.response : {}
          if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
            this.company_setup.product_catalog_id = '1'
          }
          this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '0';
          this.company_setup.is_rejected_qty_visible_in_direct_invoice=  this.company_setup.is_rejected_qty_visible_in_direct_invoice?  this.company_setup.is_rejected_qty_visible_in_direct_invoice:'0'

          // po
          this.company_setup.is_discount_applicable_in_po = this.company_setup.is_discount_applicable_in_po ? this.company_setup.is_discount_applicable_in_po : '0'
          this.company_setup.discount_type_in_po = this.company_setup.discount_type_in_po ? this.company_setup.discount_type_in_po : ''

          this.company_setup.is_service_start_end_date_visible = this.company_setup.is_service_start_end_date_visible ? this.company_setup.is_service_start_end_date_visible : '0'
          this.company_setup.pr_procured_days_name = this.company_setup.pr_procured_days_name ? this.company_setup.pr_procured_days_name : 'No Of Months Requested For'
          this.company_setup.pr_inventory_in_hand_name = this.company_setup.pr_inventory_in_hand_name ? this.company_setup.pr_inventory_in_hand_name : 'Inventory In Hand(Months)'
          this.company_setup.currency_icon = this.company_setup.currency_icon ? this.company_setup.currency_icon : '';

        }
        else {
          this.toasterService.pop('error', "Error", data.message);
        }
        this.apiCall();
      }, error => {
        this.toasterService.pop("error", "Error", "Something Went Wrong");

      }
    )
  }
  apiCall() {

    switch (this.progress_details.id) {
      case 'bulk_po_import':        

      break;
      
      default:
          this.toasterService.pop('error', "Error", "Wrong Data For item table");
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src1294910137/src/src/app/generic-ui-components/data-processing-status/data-processing-status.component.ts